import { ScrollableCurriculumTabStrip } from "@/components/ui/scrollable-curriculum-tab-strip";
import { Tabs, TabsContent, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { BeltRank } from "../../MembersArea";

const DEFAULT_TAB_SURFACE = "!bg-gray-200 !text-gray-900";

interface KeumgangProps {
  selectedBelt: BeltRank;
  getBeltColor: (belt: BeltRank) => string;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
  presentation?: "legacy" | "curriculum";
  beltTabSurfaceClass?: string;
}

/** Shared step list for legacy Movements and curriculum Pattern tab */
function KeumgangMovesOl() {
  return (
    <ol className="list-none space-y-2">
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">Ready:</span>
        <span className="text-gray-700">Ready stance</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">1.</span>
        <span className="text-gray-700">Step forward with the left foot into left Front Stance. Inner Forearm Opening Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">2.</span>
        <span className="text-gray-700">Step forward with the right foot into right Front Stance. Right Palmheel Jaw Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">3.</span>
        <span className="text-gray-700">Step forward with the left foot into the left Front Stance. Left Palmheel Jaw Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">4.</span>
        <span className="text-gray-700">Step forward with the right foot into right Front Stance. Right Palmheel Jaw Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">5.</span>
        <span className="text-gray-700">Then going backward...</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">6.</span>
        <span className="text-gray-700">
          Step backward with the right foot into right Back Stance (i.e., left foot forward). Left Knifehand Inward Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">7.</span>
        <span className="text-gray-700">
          Step backward with the left foot into left Back Stance (i.e., right foot forward). Right Knifehand Inward Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">8.</span>
        <span className="text-gray-700">Step backward with the right foot into right Back Stance. Left Knifehand Inward Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">9.</span>
        <span className="text-gray-700">
          Pivoting on the right foot, look left. Slowly draw the left foot up into Right Crane Stance. Diamond Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">10.</span>
        <span className="text-gray-700">Then going left...</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">11.</span>
        <span className="text-gray-700">Keumgang LargeHingeBlock</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">12.</span>
        <span className="text-gray-700">Step down into a Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">13.</span>
        <span className="text-gray-700">Move the right foot first to turn 360 counterclockwise.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">14.</span>
        <span className="text-gray-700">Finish the turn in Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">15.</span>
        <span className="text-gray-700">
          Pivot 90 counterclockwise on the left foot, lift the right foot and forcefully stomp into Horse-riding Stance. Mountain Block. Kihap.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">16.</span>
        <span className="text-gray-700">Then going right...</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">17.</span>
        <span className="text-gray-700">Pivot 180 clockwise on the right foot, step into Horse-riding Stance. Inner Forearm Opening Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">18.</span>
        <span className="text-gray-700">Slide the left foot into Parallel Stance. Low Opening Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">19.</span>
        <span className="text-gray-700">
          Pivot 180 clockwise on the right foot, lift the left foot and forcefully stomp into Horse-riding Stance. Mountain Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">20.</span>
        <span className="text-gray-700">Do this once...</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">21.</span>
        <span className="text-gray-700">Pivot on the left foot. Slowly draw the right foot up into Left Crane Stance. Diamond Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">22.</span>
        <span className="text-gray-700">Step down into Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">23.</span>
        <span className="text-gray-700">Move the left foot first to turn 360 clockwise.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">24.</span>
        <span className="text-gray-700">Finish the turn into Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">25.</span>
        <span className="text-gray-700">Then do it again...</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">26.</span>
        <span className="text-gray-700">Slowly draw the right foot up into Left Crane Stance. Diamond Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">27.</span>
        <span className="text-gray-700">Step down into Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">28.</span>
        <span className="text-gray-700">Move the left foot first to turn 360 clockwise.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">29.</span>
        <span className="text-gray-700">Finish the turn into Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">30.</span>
        <span className="text-gray-700">
          Pivot 90 clockwise on the right foot, lift the left foot then stomp into horseriding stance. Mountain Block. Kihap.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">31.</span>
        <span className="text-gray-700">Going left again, back to the starting point...</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">32.</span>
        <span className="text-gray-700">
          Pivot 180 counterclockwise on the left foot, step into Horse-riding Stance. Inner Forearm Opening Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">33.</span>
        <span className="text-gray-700">Slide the right foot into Parallel Stance. Low Opening Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">34.</span>
        <span className="text-gray-700">
          Pivot 180 counterclockwise on the left foot, lift the right foot then stomp into Horse-riding Stance. Mountain Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">35.</span>
        <span className="text-gray-700">
          Pivot on the right foot, look left. Slowly draw the left foot up into Right Crane Stance. Diamond Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">36.</span>
        <span className="text-gray-700">Step down into Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">37.</span>
        <span className="text-gray-700">Move the right foot first to turn 360 counterclockwise.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">38.</span>
        <span className="text-gray-700">Finish the turn in Horse-riding Stance. Large Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">End:</span>
        <span className="text-gray-700">Return to Ready stance.</span>
      </li>
    </ol>
  );
}

export default function Keumgang({
  selectedBelt,
  getBeltColor: _getBeltColor,
  hasDemo,
  onWatchDemo,
  presentation = "legacy",
  beltTabSurfaceClass = DEFAULT_TAB_SURFACE,
}: KeumgangProps) {
  // Show for 1st Dan and above
  if (!["BLACK/D1", "BLACK/D2", "BLACK/D3", "BLACK/D4", "BLACK/D5"].includes(selectedBelt)) {
    return null;
  }

  const surface = beltTabSurfaceClass;
  const triggerClass = cn(
    "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-black/10 px-3 py-2 text-xs font-medium md:text-sm",
    surface,
    "data-[state=active]:z-10 data-[state=active]:shadow-md data-[state=active]:ring-2 data-[state=active]:ring-gray-900/40 data-[state=active]:ring-offset-2 data-[state=active]:ring-offset-gray-100",
  );

  const demoBtn =
    hasDemo?.(["keumgang"]) ? (
      <button
        type="button"
        className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
        onClick={() => onWatchDemo?.(["keumgang"])}
      >
        Watch Demonstration Video
      </button>
    ) : null;

  if (presentation === "curriculum") {
    return (
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <h2 className="mb-2 text-lg font-semibold text-taekwondo-red md:text-xl">Keumgang</h2>
        {demoBtn && <div className="mb-3">{demoBtn}</div>}
        <Tabs defaultValue="pattern-information" className="w-full space-y-4">
          <ScrollableCurriculumTabStrip ariaLabelPrefix="Keumgang">
            <TabsTrigger value="pattern-information" className={triggerClass}>
              Pattern Information
            </TabsTrigger>
            <TabsTrigger value="details" className={triggerClass}>
              Details
            </TabsTrigger>
            <TabsTrigger value="meaning" className={triggerClass}>
              Meaning
            </TabsTrigger>
            <TabsTrigger value="key-techniques" className={triggerClass}>
              Key Techniques
            </TabsTrigger>
            <TabsTrigger value="pattern" className={triggerClass}>
              Pattern
            </TabsTrigger>
          </ScrollableCurriculumTabStrip>

          <TabsContent value="pattern-information" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Information</h4>
              <p className="mb-4 text-gray-700">
                Keumgang is named after Mount Keumgang, which represents strength and stability. The pattern emphasizes power and stability in stance,
                with movements that demonstrate both physical and mental fortitude.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="details" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Details</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Number of Movements: 27</li>
                <li>Pattern Diagram: Mountain (山)</li>
                <li>Starting Position: Parallel Ready Stance</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="meaning" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Meaning</h4>
              <p className="text-gray-700">
                Keumgang means &apos;diamond&apos; symbolizing hardness. Keumgang is also the name of the most beautiful mountain in Korea, as well as
                the Keumgang warrior, named by Buddha. The 27 movements (31 techniques) represent the unbreakable diamond and the mountain and should be
                performed with a strong clarity in the movements.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="key-techniques" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Key Techniques</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Mountain blocks (Keumgang makki)</li>
                <li>Guarding blocks in back stance</li>
                <li>Strong stance transitions</li>
                <li>Diamond-shaped hand formations</li>
                <li>Stability exercises</li>
                <li>Power generation from solid stances</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="pattern" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Movements</h4>
              <KeumgangMovesOl />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 p-4 rounded-lg mt-2">
      <div className="space-y-4">
        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Pattern Information</h4>
          <p className="text-gray-700 mb-4">
            Keumgang is named after Mount Keumgang, which represents strength and stability. The pattern emphasizes 
            power and stability in stance, with movements that demonstrate both physical and mental fortitude.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Pattern Details</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Number of Movements: 27</li>
            <li>Pattern Diagram: Mountain (山)</li>
            <li>Starting Position: Parallel Ready Stance</li>
          </ul>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Meaning</h4>
          <p className="text-gray-700 mb-4">
          Keumgang means 'diamond' symbolizing hardness. Keumgang is also the name of the most beautiful mountain in Korea, as well as the Keumgang warrior, named by Buddha.
          The 27 movements (31 techniques) represent the unbreakable diamond and the mountain and should be performed with a strong clarity in the movements.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Key Techniques</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Mountain blocks (Keumgang makki)</li>
            <li>Guarding blocks in back stance</li>
            <li>Strong stance transitions</li>
            <li>Diamond-shaped hand formations</li>
            <li>Stability exercises</li>
            <li>Power generation from solid stances</li>
          </ul>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Movements</h4>
          <KeumgangMovesOl />
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Training Focus</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Stance stability and power generation</li>
            <li>Mental fortitude and concentration</li>
            <li>Balance control in transitions</li>
            <li>Strong blocking techniques</li>
            <li>Grounding and centering</li>
            <li>Understanding of pattern applications</li>
          </ul>
        </div>
      </div>
    </div>
  );
} 